import Swiper from 'swiper';

export const isUserInteraction = (swiperInstance: Swiper) => {
  const { touches } = swiperInstance;
  return (
    touches?.currentX && touches?.currentX !== 0 && touches?.currentY && touches?.currentY !== 0
  );
};
